import $ from '@rover/globals/jquery';
import AppInstallSMSForm from '../forms/AppInstallSMSForm';

$(() => {
  AppInstallSMSForm.init($('.js-send-to-phone-sms'));
});



// WEBPACK FOOTER //
// ./js/pages/app.js